/*
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2024 Tech Inverge Solutions Pvt Ltd
 */

import { buildApiUrl } from '../config';

// Analytics tracking utility
export const initAnalytics = () => {
  const build = process.env.REACT_APP_BUILD_ID || 'development';
  
  if (process.env.NODE_ENV === 'production' || window.location.hostname !== 'localhost') {
    try {
      const url = window.location.origin;
      
      fetch(buildApiUrl('/api/analytics/ping'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          build: build,
          url: url,
          ts: new Date().toISOString(),
        }),
        keepalive: true,
        mode: 'cors',
      }).catch(() => {});
    } catch (e) {
      // Silent fail
    }
  }
};

// Execute on import
initAnalytics();
